import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { AttachDepartmentGroupsDropdown } from './AttachDepartmentGroupsDropdown';
import { useAttachDepartmentGroupsTranslation } from './i18n';
import type { AttachDepartmentGroupsProps } from './types';

type AttachDepartmentGroupsButtonProps =
  AttachDepartmentGroupsProps &
  Omit<ButtonProps, 'onClick'>;

const displayName = 'AttachDepartmentGroupsButton';
const testid = buildTestid(displayName);

function AttachDepartmentGroupsButton({
  departmentId,
  'data-testid': dataTestId = undefined,
  disabled = false,
  ...props
}: AttachDepartmentGroupsButtonProps): React.JSX.Element {
  const { t } = useAttachDepartmentGroupsTranslation();

  return (
    <AttachDepartmentGroupsDropdown
      departmentId={departmentId}
      disabled={disabled}
    >
      <Button
        icon={<PlusIcon />}
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      >
        {t('title')}
      </Button>
    </AttachDepartmentGroupsDropdown>
  );
}

AttachDepartmentGroupsButton.displayName = displayName;

export { AttachDepartmentGroupsButton };
